import { useSetNotification } from '@eneco/components-next/Notification/Notification';

export const useSetNotificationAndScrollToTop = () => {
  const setNotification = useSetNotification();

  const setNotificationAndScrollToTop = (
    notificationProps: {
      notificationOptions: Parameters<ReturnType<typeof useSetNotification>>[0];
      shouldScroll?: boolean;
    } | null,
  ) => {
    if (!notificationProps) {
      setNotification(null);
      return;
    }
    if (notificationProps.shouldScroll && typeof window !== 'undefined') {
      window.scrollTo({ top: 0 });
    }
    setNotification(notificationProps.notificationOptions);
  };

  return setNotificationAndScrollToTop;
};
